import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SanitizerService {

  /**
   * Sanitiza recursivamente cualquier estructura de datos
   */
  sanitize(data: any, path: string = 'root'): any {
    // Casos base: null y undefined
    if (data === null || data === undefined) {
      return data;
    }
    // Si es un string, sanitizarlo
    else if (typeof data === 'string') {
      return this.sanitizeString(data);
    }
    // Si es un array, sanitizar cada elemento
    else if (Array.isArray(data)) {
      return data.map((item, index) =>
        this.sanitize(item, `${path}[${index}]`)
      );
    }
    // Si es un objeto, sanitizar cada propiedad
    else if (typeof data === 'object') {
      const sanitized: any = {};
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          sanitized[key] = this.sanitize(data[key], `${path}.${key}`);
        }
      }
      return sanitized;
    }
    // Números, booleanos, etc.
    else {
      return data;
    }
  }

  /**
   * Sanitiza un string individual
   */
  sanitizeString(value: string | undefined | null): string {
    if (!value || typeof value !== 'string') {
      return '';
    }

    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .replace(/\//g, '&#x2F;');
  }

  /**
   * Sanitiza solo campos específicos
   */
  sanitizeFields(data: any, fields: string[]): any {
    if (!data || typeof data !== 'object') {
      return data;
    }

    const result = { ...data };

    fields.forEach(field => {
      if (result.hasOwnProperty(field)) {
        result[field] = this.sanitize(result[field], field);
      }
    });

    return result;
  }

  /**
   * Sanitiza todo excepto campos específicos
   */
  sanitizeExcept(data: any, excludeFields: string[]): any {
    if (!data || typeof data !== 'object') {
      return data;
    }

    const result: any = {};

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (excludeFields.includes(key)) {
          result[key] = data[key];
        } else {
          result[key] = this.sanitize(data[key], key);
        }
      }
    }

    return result;
  }

}
